import { render, staticRenderFns } from "./MpStokRecetesi.vue?vue&type=template&id=77f6b984"
import script from "./MpStokRecetesi.vue?vue&type=script&lang=js"
export * from "./MpStokRecetesi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports